export const OUTPUT_CONFIGURATION_TYPE = {
  collaborative: 0,
  individual: 1,
  community: 2,
  support: 3,
  specialty: 4
};
